import React from 'react';
import {executeQuery} from "../../requests/executeQuery";
import {STRIVE_FEES} from "../../consts/queries";
import {FeesPipeline} from "./FeesPipeline";
import dollars from "../../dollar-format";
import {columns, printFirstColumns, printSecondColumns} from "./columns";
import Input from "../Input";
import transactionTypes from "../../transaction-types";
import {Chip, TextField} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";
import SelectTeam from "../SelectTeam/SelectTeam";
import filter from "../../filter";
import {calculateTotalColumn, formatName, renderPrintFooter} from "../../utils";
import {getData} from "../../requests/CRUD";
import {TEAM} from "../../consts/tables";

const noPropertiesPerPage = 10;

export default class StriveFees extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: [],
            query: {
                START_DATE: `01/01/${new Date().getFullYear()}`,
                END_DATE: new Date().toLocaleDateString('en-US'),
                TRANSACTION_TYPE: 'Investment Sales,Leasing,Financing,Advisory,Referral',
                AGENT_ID: '',
                order: 'CLOSE_OF_ESCROW.asc'
            },
            agentName: '',
            isPrint: false,
            printBackground: '',
        };

        this.getValuesForDropdown = this.getValuesForDropdown.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
    }

    componentDidMount() {
        this.setState({printBackground: `url('${arc.path.media + 'Transaction_Background.png'}')`}, this.fetch);
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
    }

    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

    fetch() {
        let query = {...this.state.query};
        query = filter(query, 'striveFees');
        const agentOptions = {
            limit: {
                count: 1,
                offset: 0,
            },
            column: [
                'FIRST_NAME',
                'LAST_NAME',
            ],
            filter: [{
                code: 'ARCIMEDES_ROW_ID',
                text: this.state.query.AGENT_ID,
                type: 'exact',
            }],
        };

        Promise.all([
            executeQuery({queryName: STRIVE_FEES, options: query}),
            getData({tableCode: TEAM, options: agentOptions})
        ]).then(res => {
            if (res && res[0] && res[0].success && Array.isArray(res[0].data)) {
                const rows = res[0].data.map((data, index) => {
                    return new FeesPipeline(data, index + 1)
                });
                rows[rows.length] = new FeesPipeline({
                    TOTAL_FEE: calculateTotalColumn(rows, 'totalFee'),
                    STRIVE_FEE: calculateTotalColumn(rows, 'striveFee'),
                }, null, true);

                const state = {
                    rows,
                };
                if(res[1] && res[1].success && Array.isArray(res[1].data) && res[1].data.length) {
                    state.agentName = formatName(res[1].data[0]);
                }
                this.setState(state);
            }
        });
    }

    getValuesForDropdown(query, options, key, type = 'multiple') {
        if (!query || !options || !options.length) return [];

        let formattedQueryValues = query.ARCIMEDES_ROW_ID ? query.ARCIMEDES_ROW_ID : query.split(',');
        let response = [];

        options.forEach((el) => {
            if (!key) {
                if (formattedQueryValues.includes(el))
                    response.push(el);
            } else {
                if (formattedQueryValues.includes(el[key]))
                    response.push(el);
            }
        });

        if (!response) return [];
        if (type === "multiple") return response;
        return response[0];
    }

    handleChangeDropdown(event, reason, queryType, dropdownType = 'single', key = null) {
        const query = {...this.state.query};

        if (!reason) {
            query[queryType] = null;
        } else {
            if (dropdownType === 'single') {
                if (!key)
                    query[queryType] = reason;
                else
                    query[queryType] = reason[key];
            } else {
                let result = '';
                reason.forEach(el => {
                    if (!key)
                        result += el + ',';
                    else
                        result += el[key] + ',';
                });
                query[queryType] = result;
            }
        }

        this.setState({query});
    }

    handleChange(e) {
        const query = {...this.state.query};
        query[e.currentTarget.name] = e.currentTarget.value;
        this.setState({query});
    }

    onSubmit() {
        this.fetch();
    }

    static renderCell({row, index, column, lastIndex}) {
        let value = '';
        if (row[column.key]) {
            if (column.format === '$') {
                const withCents = column.withCents;
                value = dollars(row[column.key], withCents);
            } else if (column.format === '%') {
                value = `${row[column.key].toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
            } else {
                value = row[column.key];
            }
        }
        return (
            <td key={index+'-'+column.key} className={`${index === lastIndex ? 'Fees_footer' : 'Fees_td'} ${column.class ? column.class : ''}`}>
                {value}
            </td>
        )
    }

    renderTable(columns, rows, className, isLastTable = null) {
        const hasSubColumns = true;
        const lastIndex = isLastTable || isLastTable === null ? rows.length - 1 : null;
        return (
            <table className={className}>
                <thead>
                <tr>
                    {
                        columns.map((column, index) => {
                            const subColsNo = column.subColumns ? column.subColumns.length : 1;
                            return (
                                <th key={index}
                                    className={`Fees_th ${column.subColumns ? 'has-subcolumn' : ''}`}
                                    rowSpan={column.subColumns ? 1 : 2}
                                    colSpan={column.subColumns ? subColsNo : 1}>
                                    {column.name}
                                </th>
                            )
                        })
                    }
                </tr>
                {
                    hasSubColumns ?
                        <tr>
                            {
                                columns.map((column, index) => {
                                    if (column.subColumns) {
                                        return column.subColumns.map((subColumn, subColIndex) => {
                                            return (
                                                <th key={index+subColIndex}
                                                    className="Fees_th subcolumn">{subColumn.name}
                                                </th>
                                            )
                                        });
                                    }
                                })
                            }
                        </tr>
                        :
                        null
                }
                </thead>
                <tbody>
                {
                    rows.map((row, index) => {
                        return (
                            <tr key={index}>
                                {
                                    columns.map(column => {
                                        if (column.subColumns) {
                                            return column.subColumns.map(subCol => {
                                                return StriveFees.renderCell({row, index, column: subCol, lastIndex});
                                            });
                                        }
                                        return StriveFees.renderCell({row, index, column, lastIndex});
                                    })
                                }
                            </tr>
                        );
                    })
                }
                </tbody>
            </table>
        );
    }

    renderPrintPages({rows, date, propertyNo, agentName, isPrint, printBackground}) {
        let pageIndex = 0;
        const noTables = Math.ceil(rows.length / noPropertiesPerPage);

        return (
            [...Array(noTables)].map((value, index) => {
                const isLastTable = noTables === index + 1;
                const properties = rows.slice(pageIndex, pageIndex + noPropertiesPerPage);
                pageIndex += noPropertiesPerPage;

                return [printFirstColumns, printSecondColumns].map((cols, colsIndex) => {
                    return (
                        <div className='print-container'
                             key={`${index}-${colsIndex}`}
                             style={{backgroundImage: isPrint && printBackground}}>
                            <div className='Fees_head_left'>
                                <h3 className='Fees_h3'>STRIVE Fees</h3>
                                <h4 className='Fees_h4'>{date}</h4>
                                <h5 className='Fees_h5'>{agentName ? agentName : 'STRIVE'}</h5>
                                <h5 className='Fees_h5'>{propertyNo} Properties</h5>
                            </div>
                            {this.renderTable(cols, properties, null, isLastTable)}
                            {renderPrintFooter(isPrint)}
                        </div>
                    );
                });
            })
        );
    }

    render() {
        const d = new Date();
        const date = d.getMonth()+1+'/'+d.getDate()+'/'+d.getFullYear();
        const {rows, query, agentName, isPrint, printBackground} = this.state;
        const propertyNo = calculateTotalColumn(rows, null, true) - 1;  // without the total row

        return (
            <div className='Fees'>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
                {this.renderPrintPages({columns, rows, date, propertyNo, agentName, isPrint, printBackground})}

                <div className='Fees_head'>
                    <div className='Fees_head_left'>
                        <h3 className='Fees_h3'>STRIVE Fees</h3>
                        <h4 className='Fees_h4'>{date}</h4>
                        <h5 className='Fees_h5'>{agentName ? agentName : 'STRIVE'}</h5>
                        <h5 className='Fees_h5'>{propertyNo !== -1 ? propertyNo : 0} Properties</h5>
                        <button className='Fees_apply' onClick={this.onSubmit}>Apply</button>
                    </div>
                    <div className='Fees_head_right'>
                        <Input name='START_DATE'
                               value={query.START_DATE}
                               label='Start Date'
                               onChange={this.handleChange}
                               placeholder='MM/DD/YYYY'
                               pattern='(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])[\/]([1|2]\d\d\d)'
                        />
                        <Input
                            name='END_DATE'
                            value={query.END_DATE}
                            label='End date'
                            onChange={this.handleChange}
                            placeholder='MM/DD/YYYY'
                            pattern='(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])[\/]([1|2]\d\d\d)'
                        />
                        <SelectTeam theme='white-old agent'
                                    name='AGENT_ID'
                                    value={query.AGENT_ID}
                                    onChange={this.handleChangeDropdown}
                                    label='AGENT'
                                    getValue={this.getValuesForDropdown}
                        />
                        <Autocomplete
                            multiple className={'white-old transaction-type'}
                            options={transactionTypes}
                            value={this.getValuesForDropdown(query.TRANSACTION_TYPE, transactionTypes, null, 'multiple')}
                            renderInput={(params) => <TextField {...params} label="Transaction Type" variant="outlined"/>}
                            renderTags={(tagValue, getTagProps) =>
                                tagValue.map((option, index) =>
                                    <Chip key={index} {...getTagProps({index})} label={option[0]}/>
                                )}
                            onChange={(event, reason) => this.handleChangeDropdown(event, reason, 'TRANSACTION_TYPE', 'multiple')}
                        />
                    </div>
                </div>
                {this.renderTable(columns, rows, 'screen-table')}
            </div>
        )
    }
}